import type { ComponentType } from 'react'

import { Leaf1 } from '@/assets/svg'

// The double render is the legacy hover trick: the outlined leaf and the filled (`contained`)
// leaf are stacked, and CSS cross-fades them on hover (see .leaf-step-icon in sections.scss).
export function LeafStep({
  heading,
  description,
  icon: Icon = Leaf1,
}: {
  heading: string
  description: string
  icon?: ComponentType<{ contained?: boolean }>
}) {
  return (
    <div className="leaf-step">
      <div className="leaf-step-icon">
        <Icon />
        <Icon contained />
      </div>

      <div className="leaf-step-content">
        <h6>{heading}</h6>
        <p>{description}</p>
      </div>
    </div>
  )
}
